import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";



export function DepartmentSelect(props) {

    const handleChange = (event) => {
        const myValue = props.departmentList.find(x => x.id === event.target.value)
        props.setDepartment(myValue);

    };


    return (

        <div className="flex flex-fill justify-content-start flex-wrap flex-shrink-0 md:flex-nowrap">

                <Dropdown value={props.department.id} onChange={handleChange} options={props.departmentList}
                          optionLabel="name" optionValue="id" disabled={props.disable}
                          placeholder="" style={{fontSize: '1vw'}} tabIndex={0} filter autoFocus={true}
                          panelClassName=" flex-1 " tooltip="Select Customer" variant="filled" className="flex-1 w-10 h-2rem align-items-center justify-content-center"
                          panelStyle={{fontSize: '1vw'}}/>

        </div>
    )

}

DepartmentSelect.propTypes = {
    department: PropTypes.object.isRequired,
    setDepartment: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
    departmentList: PropTypes.array.isRequired,



}
